import { defineStyle } from '@chakra-ui/react';

export const jammingVariant = defineStyle({
  rounded: 'none',
  color: 'neutral.white',
  backgroundColor: 'blue.700',
  borderRadius: 0,
  height: 'fit-content',
  width: 'fit-content',
  opacity: 1,
  paddingY: 3,
  paddingX: 5,
  _hover: {
    backgroundColor: 'blue',
  },
  _disabled: {
    opacity: 0.6,
  },
});
